import { Body1, Body1Strong, makeStyles, Spinner, tokens } from '@fluentui/react-components'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorPageLayout } from '../../components/ErrorPageLayout/ErrorPageLayout'
import { SplashScreen } from '../../components/SplashScreen/SplashScreen'
import { useAuth } from '../../hooks'

const useStyles = makeStyles({
  page: {
    padding: tokens.spacingVerticalL,
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: tokens.spacingVerticalL,
    '& p': { textAlign: 'center' },
  },
  tip: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
})

interface LoginProps {
  // Controlled by ProtectedRoute — true for first 5s regardless of auth state
  showSplash: boolean
}

const Login = ({ showSplash }: LoginProps) => {
  const { login, error, isAuthenticated } = useAuth()
  const { t } = useTranslation()
  const classes = useStyles()

  useEffect(() => {
    if (!isAuthenticated) {
      login()
    }
  }, [login, isAuthenticated])

  if (error) {
    return (
      <ErrorPageLayout title={t('login.errorTitle')} body={t('login.errorBody')}>
        <div className={classes.tip}>
          <Body1Strong as="p">{t('login.checkAccount.label')}</Body1Strong>
          <Body1 as="p">{t('login.checkAccount.description')}</Body1>
        </div>
      </ErrorPageLayout>
    )
  }

  if (showSplash) {
    return <SplashScreen />
  }

  return (
    <div className={classes.page}>
      <div className={classes.container}>
        <Spinner label={t('login.loading')} labelPosition="below" />
      </div>
    </div>
  )
}

export { Login }
